module.exports = __webpack_public_path__ + "static/img/food-kpf.667d014.svg";


//////////////////
// WEBPACK FOOTER
// ./static/food-kpf.svg
// module id = 1pTE
// module chunks = 1